// extracted by mini-css-extract-plugin
export var button = "Tabs-module--button--jMOJX";
export var component = "Tabs-module--component--zmJK6";
export var componentInner = "Tabs-module--componentInner--ryvW7";
export var item = "Tabs-module--item--EWX9D";
export var list = "Tabs-module--list--kToFQ";